export default {
  USER_LOGIN: 'USER_LOGIN',
  USER_LOGIN_WITH_GOOGLE: 'USER_LOGIN_WITH_GOOGLE',
  USER_SET: 'USER_SET',
  USER_REGISTER: 'USER_REGISTER',
  USER_FORGOT_PASSWORD: 'USER_FORGOT_PASSWORD',
  USER_CHANGE_PASSWORD: 'USER_CHANGE_PASSWORD',
  USER_UPDATE_PROFILE: 'USER_UPDATE_PROFILE',
  USER_VERIFY_EMAIL: 'USER_VERIFY_EMAIL',
  USER_LOGOUT: 'USER_LOGOUT',
};
